import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

export const LiveProductLinks = () => (
  <li>
    <Link to="/live/features">
      <FormattedMessage id="header.link.live.features" defaultMessage="How it works" />
    </Link>
  </li>
);
